/**
 * Skryje úvodní splash (logo.svg s černým pozadím) po načtení aplikace.
 */
export function dismissSplash() {
  const splash = document.getElementById('app-splash');
  if (!splash) {
    return;
  }
  splash.classList.add('app-splash--hide');
  window.setTimeout(() => {
    splash.remove();
    document.body.style.backgroundColor = '';
    const root = document.getElementById('root');
    if (root) {
      root.style.backgroundColor = '';
    }
  }, 300);
}
